// extracted by mini-css-extract-plugin
export default {"root":"GridBase_root__s2zoR"};